export default {
  profile_page: {
    profile: {
      title: 'Perfil',
      form: {
        email_label: 'Dirección Email',
        update_email_button: 'Actualizar Email',
      },
    },
    password: {
      title: 'Contraseña',
      form: {
        current_pass_label: 'Contraseña Actual',
        new_pass_label: 'Nueva Contraseña',
        repeat_pass_label: 'Confirmar Nueva Contraseña',
        update_pass_button: 'Actualizar Contraseña',
      },
      actions: {
        update_pass: {
          message_1: '¿Está seguro de actualizar su contraseña?',
          message_2: 'Precaución',
          confirm: 'Si, cambiar contraseña',
          cancel: 'No, cancelar',
          success: {
            title: 'Perfil',
            message: 'Contraseña actualizada correctamente.',
          },
          error: {
            title: 'Perfil',
            message: 'Ha ocurrido un error al actualizar su contraseña.',
          },
        },
        update_profile: {
          message_1: '¿Está seguro de actualizar su perfil?',
          message_2: 'Precaución',
          confirm: 'Si, actualizar',
          cancel: 'No, cancelar',
          success: {
            title: 'Perfil',
            message: 'Perfil actualizado correctamente.',
          },
          error: {
            title: 'Perfil',
            message: 'Ha ocurrido un error al actualizar su perfil.',
          },
        },

      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/account/profile.js